module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/147-bangladesh-c5a52380c10c1e14e25805f7ad220578.svg";